import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ScreenService } from 'app/shared/services/screen.service';
import { BasemapItemLike } from '../../../../toc.service';
import { Subject, takeUntil } from 'rxjs';

const defaultBasemapImageUrl =
  'https://js.arcgis.com/4.23/@arcgis/core/assets/esri/themes/base/images/basemap-toggle-64.svg';

@Component({
  selector: 'app-basemap-gallery',
  templateUrl: 'basemap-gallery.component.html',
  styleUrls: ['basemap-gallery.component.scss'],
})
export class BasemapGalleryComponent {
  private lifecycle = new Subject<void>();

  @Input()
  basemapItems: BasemapItemLike[];

  @Input()
  selectedIndex: number;
  @Output()
  selectedIndexChange = new EventEmitter<number>();

  @Input()
  allowDeselect = false;

  @Output()
  onBasemapItemSelected = new EventEmitter<BasemapItemLike>();

  defaultBasemapImageUrl = defaultBasemapImageUrl;

  isMobileScreen: boolean = false;

  constructor(private screenService: ScreenService) {}

  ngOnInit() {
    this.screenService
      .observeIsMobile()
      .pipe(takeUntil(this.lifecycle))
      .subscribe((isMobile) => {
        this.isMobileScreen = isMobile;
      });
  }

  onBasemapItemClick(item: BasemapItemLike, index: number) {
    if (this.selectedIndex === index) {
      if (!this.allowDeselect) {
        return;
      }

      index = -1;
      item = null;
    }

    this.selectedIndex = index;
    this.selectedIndexChange.emit(this.selectedIndex);

    this.onBasemapItemSelected.emit(item);
  }
}
